
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
const namespace = "StudioModule";

@Component
export default class ColorBox extends Vue {
  @Action('updateScale', { namespace }) private updateScale!: () => any;
  @Mutation('setMode', {namespace}) private setMode!: (value: number) => any;
  @State ("mode", { namespace }) private mode!: number;

  private handleClick(value: number){
    this.setMode(value);
    this.updateScale();
  }
}
